import { z } from 'zod';

import { CostMode } from '../models';

export interface ScheduleApi {
  id: string;
  Mo: number;
  Tu: number;
  We: number;
  Th: number;
  Fr: number;
  Sa: number;
  Su: number;
  from: string;
  to: string;
  costMode: CostMode;
  driverId: string;
}

export interface Schedule {
  id: string;
  Mo: boolean;
  Tu: boolean;
  We: boolean;
  Th: boolean;
  Fr: boolean;
  Sa: boolean;
  Su: boolean;
  from: string;
  to: string;
  costMode: CostMode;
  driverId: string;
}

export const scheduleSchema = z.object({
  Mo: z.boolean(),
  Tu: z.boolean(),
  We: z.boolean(),
  Th: z.boolean(),
  Fr: z.boolean(),
  Sa: z.boolean(),
  Su: z.boolean(),
  from: z.date(),
  to: z.date(),
  costModeId: z.string().uuid('Debe ser un UUID válido'),
});

export type ScheduleSchema = z.infer<typeof scheduleSchema>;
